<div>
    <!-- header -->
    <h2 mat-dialog-title mat-dialog-draggable-title> {{'title.synchronized_document_group' | translate}}
        <button type="button" class="close" aria-label="Close" (click)="onBtnCancelClick()">
            <span aria-hidden="true">&times;</span>
        </button>
    </h2>
    <!-- end header -->
    <mat-divider></mat-divider>
    <mat-dialog-content>
        <mat-accordion #accordion="matAccordion" [multi]="true">
            <mat-expansion-panel expanded="true" class="mt-3">
                <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                    {{ "title.search_condition" | translate }}
                </mat-panel-title>
                <form #f="ngForm" class="pb-3" (ngSubmit)="onClickBtnFilter()" (keydown.enter)="onClickBtnFilter()">
                    <div class="row">
                        <div class="col-8">
                            <mat-form-field class="w-100">
                                <input
                                    (focusout)="documents.name = documents.name == undefined ? '' : (documents.name + '').trim()"
                                    #focusInput matInput type="text"
                                    [placeholder]="'search_form.service_type_name_code' | translate" name="name"
                                    [(ngModel)]="documents.name" autocomplete="off" />
                                <button mat-button *ngIf="documents.name" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.name=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <!-- trang thai -->
                            <mat-form-field class="w-100">
                                <mat-select id="syncStatus" name="syncStatus"
                                    [placeholder]="'headertable.sync_status' | translate"
                                    [(ngModel)]="documents.syncStatus" (ngModelChange)="onClickBtnFilter()">
                                    <mat-option value="">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_select_all"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="SYNCED">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_synced"
                                        | translate
                                        }}
                                    </mat-option>
                                    <mat-option value="NOT_SYNCED">
                                        {{
                                        "system_document_template.cbx_document_status.cbx_document_status_not_synced"
                                        | translate
                                        }}
                                    </mat-option>
                                </mat-select>
                                <button mat-button *ngIf="documents.syncStatus" type="button" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="documents.syncStatus=''">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <button mat-stroked-button color="primary" type="submit">
                                <mat-icon class="mr-0" style="font-weight: 900">search</mat-icon>
                                {{ "search_form.search" | translate }}
                            </button>
                        </div>
                    </div>
                </form>

                <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                    <span *ngIf="!commonService.getIsLockedEnterprise()">{{'service_type.service_type_sync_list'
                        |
                        translate}}
                        ({{paginate.totalRow}}), {{'enterprise_customer_management.selected' | translate}}
                        {{this.dataSelected.size}}
                    </span>
                    <span *ngIf="commonService.getIsLockedEnterprise()">{{'service_type.service_type_sync_list'
                        |
                        translate}}
                        ({{paginate.totalRow}})
                    </span>
                </mat-panel-title>

                <div class="mat-table-container">
                    <mat-table [dataSource]="dataSource" width="100%">
                        <!-- check-->
                        <ng-container matColumnDef="check">
                            <mat-header-cell *matHeaderCellDef
                                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                                <mat-checkbox [disabled]="commonService.getIsLockedEnterprise()"
                                    *ngIf="dataSource && dataSource.data && dataSource.data.length > 0"
                                    [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                <mat-checkbox color="primary" [(ngModel)]="element.checked"
                                    (change)="onSelectionChange(element)"
                                    [disabled]="commonService.getIsLockedEnterprise()">
                                </mat-checkbox>
                            </mat-cell>
                        </ng-container>
                        <!-- STT -->
                        <ng-container matColumnDef="id">
                            <mat-header-cell *matHeaderCellDef
                                class="special mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                                <div>{{'enterprise_contract.table_headers.No' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"
                                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                {{paginate.no[dataSource.filteredData.indexOf(element)]}}
                            </mat-cell>
                        </ng-container>

                        <!-- group name -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef
                                class=" special mat-header-cell-center mat-cell-non-boder-right-bottom">
                                <div>{{'headertable.service_type_name' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.name }}"
                                class="d-flex align-items-center mat-cell-non-boder-right-bottom"
                                (click)="$event.stopPropagation()">
                                <ng-container *ngIf="element.type == 2">
                                    <i style="font-size: 10px;" class="fa fa-star text-primary mr-1"></i>
                                </ng-container>
                                {{element.name}}
                            </mat-cell>
                        </ng-container>

                        <!-- Code -->
                        <ng-container matColumnDef="code">
                            <mat-header-cell *matHeaderCellDef
                                class="special mat-header-cell-center mat-cell-non-boder-right-bottom">
                                <div>{{'search_form.service_type_code' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.code }}"
                                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                                {{element.code}}
                            </mat-cell>
                        </ng-container>

                        <!-- Ghi chú Column -->
                        <ng-container matColumnDef="note">
                            <mat-header-cell *matHeaderCellDef class="special mat-header-cell-center">
                                <div>{{'headertable.note' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.note }}"
                                (click)="$event.stopPropagation()">
                                {{element.note}}
                            </mat-cell>
                        </ng-container>

                        <!-- Trạng thái đồng bộ Column -->
                        <ng-container matColumnDef="status_sync">
                            <mat-header-cell *matHeaderCellDef style="max-width: 160px"
                                class="special mat-header-cell-center">
                                <div>{{'headertable.sync_status' | translate}}</div>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element" matTooltip="{{ element.syncStatusMessage }}"
                                style="max-width: 160px" (click)="$event.stopPropagation()" class="number-cell-center">
                                <span *ngIf="element.syncStatus === 'SYNCED'" class="title-status-sync synced">{{
                                    'system_document_template.cbx_document_status.cbx_document_status_synced' |
                                    translate
                                    }}</span>
                                <span *ngIf="element.syncStatus === 'NOT_SYNCED'"
                                    class="title-status-sync not-synced">{{
                                    'system_document_template.cbx_document_status.cbx_document_status_not_synced' |
                                    translate }}</span>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    </mat-table>
                </div>
                <!-- Pagination -->
                <app-pagination [(paginate)]="paginate" (pageChange)="onPageChange($event.page, $event.pageSize)">
                </app-pagination>
                <!-- /Pagination -->
            </mat-expansion-panel>
        </mat-accordion>
    </mat-dialog-content>
    <div>
        <p class="mb-0 mt-3">
            <b><i>{{'synchronized.note' | translate}}</i></b>
            <i>{{'synchronized.synchronized_note' | translate}}</i>
        </p>
    </div>
    <!-- Huỷ bỏ & Đồng bộ & Đồng bộ tất cả  -->
    <mat-dialog-actions class="mt-2" align="center">
        <button mat-stroked-button color="primary" class="mr-3 mb-1" (click)="onBtnCancelClick()" type="button">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.close' | translate}}
        </button>
        <button mat-raised-button type="button" color="primary" class="mr-3" (click)="synchronizeSelectedRecords()"
            [disabled]="this.dataSelected.size == 0">
            <mat-icon class="mr-0">refresh</mat-icon>
            {{'button.synchronized' | translate}}
        </button>
        <button mat-raised-button type="button" color="primary" (click)="synchronizeAll()"
            [disabled]="this.dataSource.data.length == 0">
            <mat-icon class="mr-0">folder</mat-icon>
            {{'button.synchronized_all' | translate}}
        </button>
    </mat-dialog-actions>
</div>